import { defineMessages } from "react-intl";

const baseId = "t.components.modals.TimeExpiredModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "Time Expired",
  },
  description_one: {
    id: baseId + "description_one",
    defaultMessage: "Session expired.",
  },
  description_two: {
    id: baseId + "description_two",
    defaultMessage: "Please go back to the login and repeat the access",
  },
  CTA_LOGOUT: {
    id: baseId + "CTA_LOGOUT",
    defaultMessage: "LOGOUT",
  },
});
